var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiTlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.71 164.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: red;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m490.71,60.73v-25.39h-119.91v25.39h119.91Zm-152.2,0h22.65v-25.39h-22.65V0h-27.14v35.33h-11.82v25.39h11.82l-.04,34.4.04,34.43h27.14V60.73h0Zm-74.88,68.83h26.27V35.33h-26.27v94.22h0Zm0-103.28h26.27V0h-26.27v26.27h0Zm-11.06,56.17h0c0-26.02-21.09-47.11-47.11-47.11h-75.91v25.39h0v104.19h27.18V60.73h48.73c12,0,21.72,9.72,21.72,21.72h0c0,12-9.72,21.72-21.72,21.72h-38.92v25.39h38.92c26.02,0,47.11-21.09,47.11-47.11h0ZM0,129.56h119.91v-25.39H0v25.39h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiTlogo);
export default __webpack_public_path__ + "static/media/PITlogo.2a3d156c83dd38f0d9e6123401744730.svg";
export { ForwardRef as ReactComponent };